import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getCampaigns } from '../api'
import { C, ui } from '../theme'

// Landing page at /campaign (and the fallback for an unknown /campaign/:id).
// Lists the campaigns that exist and links each to its own URL.
export default function CampaignPicker({ notFoundId }) {
  const [campaigns, setCampaigns] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    getCampaigns()
      .then(list => { if (!cancelled) setCampaigns(list || []) })
      .catch(e => { if (!cancelled) setError(e.message) })
    return () => { cancelled = true }
  }, [])

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: C.paper, color: C.ink }}>
      <div style={{ ...ui.card, width: 420, maxWidth: '90vw', padding: 28 }}>
        <h1 style={{ fontFamily: "'Cinzel', serif", fontWeight: 700, fontSize: 22, letterSpacing: 1, margin: '0 0 4px' }}>TACITVS</h1>
        <div style={{ color: C.inkSoft, fontSize: 14, marginBottom: 18 }}>Choose a campaign</div>

        {notFoundId != null && (
          <div style={{ marginBottom: 16, padding: '8px 11px', borderRadius: 4, fontSize: 13,
            background: C.paperSunken, border: `1px solid ${C.crimson}`, color: C.ink }}>
            ⚠ Campaign <strong>{String(notFoundId)}</strong> doesn’t exist. Pick one below.
          </div>
        )}

        {error && <div style={{ color: C.crimson, fontSize: 14 }}>⚠ {error}</div>}
        {!error && campaigns == null && <div style={{ color: C.inkFaint, fontSize: 14 }}>Loading…</div>}
        {!error && campaigns != null && campaigns.length === 0 && (
          <div style={{ color: C.inkFaint, fontSize: 14 }}>No campaigns found. Import a map first.</div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {(campaigns || []).map(c => (
            <Link key={c.id} to={`/${c.id}`}
              style={{ ...ui.card, display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
                padding: '11px 14px', textDecoration: 'none', color: C.ink, background: C.paperRaised }}>
              <span style={{ fontWeight: 600, fontSize: 15 }}>{c.name}</span>
              <span style={{ color: C.inkFaint, fontSize: 12 }}>day {c.current_day} · /{c.id}</span>
            </Link>
          ))}
        </div>

        <div style={{ marginTop: 18, paddingTop: 14, borderTop: `1px solid ${C.rule}`, textAlign: 'center' }}>
          <Link to="/guide" style={{ color: C.gold, fontSize: 13.5, textDecoration: 'none' }}>❔ Field Guide — how everything works</Link>
        </div>
      </div>
    </div>
  )
}
